import { createStore } from "jotai";

export const yalloStore = createStore();
